import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { useStore } from "./state.js";
import { getStorage, Logout } from "./helper";
import { setNavigate } from './navigationHelper';
import { IdleTimerProvider } from 'react-idle-timer';

import { Button, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import Form from 'react-bootstrap/Form';
import {
  Routes,
  Route,
  BrowserRouter,
  Link,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";

import reportWebVitals from './reportWebVitals';

import './styles.css';
import MainLayout from "./layout";
import Login from "./routes/login/index.js";
import ForgotPassword from "./routes/forgot_password/index.js";
import SelectCompany from "./routes/select-company/index.js";

import Home from "./routes/home";
import AccountMaster from "./routes/account_master";
import InventoryMaster from "./routes/inventory_master";
import Journal from "./routes/journals";
import Receipts from "./routes/receipts";
import Payments from "./routes/payments";
import Invoices from "./routes/invoices";
import Invoice from "./routes/invoice";
import Purchase from "./routes/purchase";
import Users from "./routes/users";
import Roles from "./routes/roles";
import ItemGroups from "./routes/item_groups";
import VoucherSeries from "./routes/voucher_series";
import Purchases from "./routes/purchases";
import Attendance from "./routes/attendance";
import Ledger from "./routes/ledger";
import Settings from "./routes/settings";
import ChangePassword from "./routes/change-password";
import OutstandingReport from "./routes/outstanding_balance";
import InventoryReport from "./routes/inventory_report";
import AttendanceReport from "./routes/attendance_report";
import ProfitLoss from "./routes/pnl";
import BalanceSheet from "./routes/balance_sheet";
import Daybook from "./routes/daybook";


import Account from "./modals/account.js";
import Inventory from "./modals/inventory.js";
import JournalVoucher from "./modals/journal_voucher.js";
import ItemGroup from "./modals/item_group.js";
import VoucherSeriesModal from "./modals/voucher_series.js";
import AttendanceModal from "./modals/attendance.js";
import User from "./modals/user.js";
import Role from "./modals/role.js";
import Company from "./modals/company.js";
import Fy from "./modals/fy.js";
import SendWA from "./modals/send_wa.js";
import BulkPdf from "./modals/bulk_pdf.js";
import ReportSend from "./modals/report_send.js";
import NiceModal, { ModalDef, useModal } from '@ebay/nice-modal-react';





if (getStorage('token')) {
  useStore.setState({ auth: 1 });
  //setAuth('1');

}
function AuthRoute({ children }) {
  const auth = useStore((state) => state.auth)
  let location = useLocation();
  const org = useStore((state) => state.org)
  if (!auth) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  

 

  return children;
}


function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}





export default function App() {

  const idleTimerRef = useRef(null);
  const location = useLocation();
  useEffect(() => {


  }, [location]);

  const navigate = useNavigate();
    
    React.useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);



  return (
    <>
    <IdleTimerProvider
      ref={idleTimerRef}
      timeout={10 * 60 * 1000}
      onIdle={()=>Logout()} 
      debounce={500} 
    >
      <Routes>

        <Route path="/" element={<MainLayout />}  >
          <Route path="/" element={<AuthRoute><Home /></AuthRoute>} />
          <Route path="account-master" element={<AuthRoute><AccountMaster /></AuthRoute>} />
          <Route path="inventory-master" element={<AuthRoute><InventoryMaster /></AuthRoute>} />
          <Route path="journal" element={<AuthRoute><Journal /></AuthRoute>} />
          <Route path="receipts" element={<AuthRoute><Receipts /></AuthRoute>} />
          <Route path="payments" element={<AuthRoute><Payments /></AuthRoute>} />
          <Route path="item-groups" element={<AuthRoute><ItemGroups /></AuthRoute>} />
          <Route path="voucher-series" element={<AuthRoute><VoucherSeries /></AuthRoute>} />
          <Route path="invoices" element={<AuthRoute><Invoices /></AuthRoute>} />
          <Route path="purchases" element={<AuthRoute><Purchases /></AuthRoute>} />
          <Route path="users" element={<AuthRoute><Users /></AuthRoute>} />
          <Route path="roles" element={<AuthRoute><Roles /></AuthRoute>} />
          <Route path="attendance" element={<AuthRoute><Attendance /></AuthRoute>} />
          <Route path="invoice/:id" element={<AuthRoute><Invoice /></AuthRoute>} />
          <Route path="purchase/:id" element={<AuthRoute><Purchase /></AuthRoute>} />
          <Route path="ledger" element={<AuthRoute><Ledger /></AuthRoute>} />
          <Route path="settings" element={<AuthRoute><Settings /></AuthRoute>} />
          <Route path="change-password" element={<AuthRoute><ChangePassword /></AuthRoute>} />
          <Route path="outstanding-report" element={<AuthRoute><OutstandingReport /></AuthRoute>} />
          <Route path="inventory-report" element={<AuthRoute><InventoryReport /></AuthRoute>} />
          <Route path="attendance-report" element={<AuthRoute><AttendanceReport /></AuthRoute>} />
          <Route path="pnl" element={<AuthRoute><ProfitLoss /></AuthRoute>} />
          <Route path="balance-sheet" element={<AuthRoute><BalanceSheet /></AuthRoute>} />
          <Route path="daybook" element={<AuthRoute><Daybook /></AuthRoute>} />



        </Route>
        <Route path="select-company" element={<AuthRoute><SelectCompany /></AuthRoute>} />

        <Route path="*" element={<NoMatch />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />


      </Routes>
      <ModalDef id="account" component={Account} />
      <ModalDef id="inventory" component={Inventory} />
      <ModalDef id="journal_voucher" component={JournalVoucher} />
      <ModalDef id="item_group" component={ItemGroup} />
      <ModalDef id="voucher_series" component={VoucherSeriesModal} />
      <ModalDef id="attendance" component={AttendanceModal} />
      <ModalDef id="user" component={User} />
      <ModalDef id="role" component={Role} />
      <ModalDef id="company" component={Company} />
      <ModalDef id="fy" component={Fy} />
      <ModalDef id="send_wa" component={SendWA} />
      <ModalDef id="bulk_pdf" component={BulkPdf} />
      <ModalDef id="report_send" component={ReportSend} />
      


      </IdleTimerProvider>

    </>
  );
}





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
